import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import Image from 'utils/image';
import { withProductContext } from './product-context';
import Video from './video';
import ProductBadge from './product-badge';

const ProductMainGallery = ({ actualProduct: { media, tags } }) => {
  const [caption, setCaption] = useState('');
  useEffect(() => {
    if (media && media.length > 0) {
      // eslint-disable-next-line max-len
      const mediaAltArray = media.map(
        (mediaEl) => mediaEl && mediaEl.image && mediaEl.image.alt,
      );
      if (mediaAltArray[0]) {
        const splitCaption = mediaAltArray[0].split('|');
        setCaption(splitCaption.length > 1 ? splitCaption[1].trim() : '');
      } else {
        setCaption('');
      }
    }
  }, [media]);

  const renderMedia = () => (
    media.map((mediaEl, index) => (
      <div key={mediaEl.id} className="media-container">
        {index === 0 && <ProductBadge tags={tags} />}
        {mediaEl.mediaContentType.toLowerCase() === 'image' ? (
          <Image
            {...mediaEl.image}
            loading={index === 0 ? 'eager' : 'lazy'}
            classes="media-image"
          />
        ) : (
          <Video
            video={mediaEl}
            autoPlay={false}
            controls
            classes="media-video"
          />
        )}
      </div>
    ))
  );

  return (
    <div className="pdp-gallery grid grid-cols-2 gap-3">
      {renderMedia()}
      {caption && (
        <div className="caption-container">
          <span>{caption}</span>
        </div>
      )}
    </div>
  );
};

export default withProductContext(ProductMainGallery);
